import { FEATURES, MODULES } from '../constants/template-info'
import { LocalStorageData } from '../domains/contentful/LocalStorageDataWithExpiry'

import { captureException } from './sentryUtil'

export const getFromSessionStorageWithExpiry = (key: string): string | null => {
  try {
    const now = new Date()
    const val = sessionStorage.getItem(key)
    if (val) {
      const data: LocalStorageData = JSON.parse(val)
      if (now.getTime() > data.expiryInMs) {
        sessionStorage.removeItem(key)
        return null
      }
      return data.value
    }
  } catch (error) {
    captureException('setInSessionStorageWithExpiry error', {
      module: MODULES.SESSION_STORAGE,
      feature: FEATURES.GET_FROM_SESSION_STORAGE_WITH_EXPIRY,
      extraInfo: {
        // @i18n-ignore
        capturedFrom: 'Get in session storage with expiry function',
        sessionStorageKey: key,
        errorDetail: JSON.stringify(error),
      },
    })
  }
  return null
}

export const isSessionStorageEnabled = () => {
  console.warn('isSessionStorageEnabled is deprecated. Use EnhancedSessionStorage utility instead.')
  // @i18n-ignore
  const testKey = 'test'
  try {
    sessionStorage.setItem(testKey, '1')
    sessionStorage.removeItem(testKey)
    return true
  } catch (error) {
    captureException('Session storage is not enabled', {
      module: MODULES.SESSION_STORAGE,
      feature: FEATURES.GET_FROM_SESSION_STORAGE_WITH_EXPIRY,
    })
    return false
  }
}
